<!--
  - Copyright (c) 2020. Minerva Networks.
  - All rights reserved.
  -->

<template>
  <div class="a-liveLogo">
    <img :src="`${assetsUrl}img/newlogo.png`" alt="A-live">
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { get } from 'lodash';

export default {
  name: 'AliveLogo',
  data() {
    return {
      get,
    };
  },
  computed: {
    ...mapState(['conf', 'env']),
    assetsUrl() {
      return get(this.conf, `${this.env}.assetsUrl`, '/');
    },
  },
};
</script>

<style scoped lang="scss">
.a-liveLogo {
  display: flex;
  align-items: center;
  img {
    display: block;
    max-width:230px;
    max-height:55px;
    width: auto;
    height: auto;
  }

  &__logo {
    margin-right: 20px;
  }

  &__name {
  }
}
</style>
